import { urlConfig } from "../../config/urlConfig";
import { postCall } from "../httpService";

const GetActivityReport = urlConfig.GetActivityReport;
const GetActivityReportDetail = urlConfig.GetActivityReportDetail;
const ActivityReportScheduleGrid = urlConfig.ActivityReportScheduleGrid;
const ScheduleActivityReport = urlConfig.ScheduleActivityReport;
const ScheduleActivityReportEdit = urlConfig.ScheduleActivityReportEdit;

export const getActivityReportsData = async (params: any) => {
  try {
    const response = await postCall(GetActivityReport, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const getActivityReportDetails = async (params: any) => {
  try {
    const response = await postCall(GetActivityReportDetail, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const getActivityReportScheduleGrid = async (params: any) => {
  try {
    const response = await postCall(ActivityReportScheduleGrid, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const scheduleActivityReport = async (params: any) => {
  try {
    const response = await postCall(ScheduleActivityReport, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const scheduleActivityReportEdit = async (params: any) => {
  try {
    const response = await postCall(ScheduleActivityReportEdit, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};
